import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { ErrorInfo } from '../../models/error/error-info';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { STORAGE_KEYS } from '../../enums/commission';

@Injectable({
  providedIn: 'root',
})
export class ErrorModalService {
  private errorSubject = new Subject<ErrorInfo>();

  constructor(private authService: AuthService) {}

  showError(httpErrorResp: HttpErrorResponse): void {
    this.errorSubject.next(this.getErrorInfoFromCode(httpErrorResp));
  }

  showErrorTest(httpErrorResp: HttpErrorResponse): void {
    this.errorSubject.next(this.getErrorInfoFromCode(httpErrorResp));
  }

  getSubject(): Subject<ErrorInfo> {
    return this.errorSubject;
  }

  getErrorInfoFromCode(httpErrorResp: HttpErrorResponse): ErrorInfo {
    const status: string = httpErrorResp.status.toString();

    switch (status) {
      case '401':
      case '403':
        this.authService.isLogged = false;
        localStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        return new ErrorInfo(
          status,
          ' La sessione è scaduta, si prega di effettuare nuovamente il login',
          () => {
            this.authService.initiateLogin();
          }
        );
      default:
        return new ErrorInfo(
          httpErrorResp.error.code,
          httpErrorResp.error.message || 'Errore generico',
          () => {
            window.open('/', '_self');
          }
        );
    }
  }
}
